import { apiPath } from './api.path';
import { instance } from './axios';

async function getOverviewAPI(params) {
  return instance.get(apiPath.getOverview, params).then((response) => response.data);
}

async function addOverviewAPI(params) {
  const bodyFormData = new FormData();
  if (params.image) {
    bodyFormData.append('image', params.image);
  }
  bodyFormData.append('name', params.name);
  bodyFormData.append('parent', params.parent);
  return instance.post(apiPath.addOverview, bodyFormData).then((response) => response.data);
}

async function getOverviewListAPI(params) {
  return instance.get(apiPath.getOverviewList, params).then((response) => response.data);
}

async function getPageListingAPI() {
  return instance.get(apiPath.getPageListing).then((response) => response.data);
}

async function addtoOverviewListAPI(params) {
  return instance.post(apiPath.addOverviewList, params).then((response) => response.data);
}

const overviewService = {
  getOverviewAPI,
  addOverviewAPI,
  getOverviewListAPI,
  getPageListingAPI,
  addtoOverviewListAPI
};
export default overviewService;
